export const formatPrice = (value: number): number => {
  return +value.toFixed(2) * 100;
};

export const formatViewPrice = (value: number): string => {
  return String(value / 100).replace('.', ',');
};
